import { LitElement, html, css } from 'lit';
import { accessibility, grid, details } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { provisionIcon, yellowTick, expandIcon, collapseIcon, arrow, arrowBack, icons, star } from '../../utilities/icons';
import { formatDateString } from '../../utilities/eventUtilities';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInMember extends AllInSessionStorage(LitElement) {
    static properties = {
        name: { type: String },
        member: { type: Object },
        nonce: { type: String },
        restUrl: { type: String },
        icons: { type: Array },
        provisions: { type: Array },
        _provisionData: { state: true, type: Array },
        _evidenceData: { state: true, type: Array },
    };
    constructor() {
        super();
        this._provisionData = [];
        this._evidenceData = [];
        this.provisions = [];
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        if (!this.provisions?.length) {
            this._getMembershipProvisionsFromSessionStorage();
            if (!this.provisions?.length) {
                await this._fetchProvisions();
            }
        }
        this._provisionData = [];
        this._evidenceData = [];
        this.provisions.forEach((item) => {
            let newProv = { title: item.title, provisions: {
                    required: [],
                    preferred: [],
                    evidence: [],
                } };
            item.provisions.forEach((provision) => {
                let provId = provision.id;
                let existingProvision = this.member?.provisions?.find((prov) => prov.standard?.id == provId || prov.id == provId);
                if (existingProvision) {
                    existingProvision.description = provision.description;
                    existingProvision.name = provision.name;
                    if (existingProvision.level == 'Required') {
                        newProv.provisions.required.push(existingProvision);
                    }
                    else if (existingProvision.level == 'Preferred') {
                        newProv.provisions.preferred.push(existingProvision);
                    }
                }
                if ((existingProvision?.evidence?.length || provision.evidenceRequired == "1") && (existingProvision?.level == 'Required' || existingProvision?.level == 'Preferred')) {
                    this._evidenceData.push(existingProvision ?? { ...provision, evidence: [] });
                }
            });
            this._provisionData.push(newProv);
        });
    }
    firstUpdated() {
        window.scrollTo(0, 0);
        if (this.member) {
            this.eventManager.emit(`allin-header-${this.name}`, { name: this.name, text: `${this.member.firstName} ${this.member.lastName} ${'member profile'}` });
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('member')) {
            if (this.member) {
                this.eventManager.emit(`allin-header-${this.name}`, { name: this.name, text: `${this.member.firstName} ${this.member.lastName} ${'member profile'}` });
            }
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    /* updated(changedProperties){

    } */
    render() {
        let main = '';
        if (!this.member) {
            main = html `<allin-loader></allin-loader>`;
        }
        else {
            let details = [];
            details.push(html `<dt>Member Name:</dt><dd>${this.member.firstName} ${this.member.lastName}</dd>`);
            details.push(html `<dt>Member Number:</dt><dd>${this.member.allInMemberNumber}</dd>`);
            if (this._evidenceData.length) {
                details.push(html `<dt>Supporting documents:</dt><dd><ul>${this._evidenceData.map(evidence => {
                    let status = evidence?.evidence[0]?.status;
                    if (status == 'Approved') {
                        status = `${`Valid until`} ${formatDateString(evidence.evidence[0].validUntil, false, false)}`;
                    }
                    else if (status == 'AwaitingApproval') {
                        status = `Awaiting verification`;
                    }
                    else {
                        status = `Not submitted`;
                    }
                    return html `<li><span>${evidence.name}</span> <span class="status">${status}</span></li>`;
                })}</ul></dd>`);
            }
            ;
            let provisionsLoop = this._provisionData?.map((item) => {
                let markup = [];
                if (item.provisions.required.length) {
                    markup.push(html `<p class="indent">I require:</p>`);
                    let requireList = item.provisions.required.map(provision => html `<li><span>${yellowTick}</span><p><strong>${provision.name}</strong><br>${provision.description}</p></li>`);
                    markup.push(html `<ul class="required">${requireList}</ul>`);
                }
                if (item.provisions.preferred.length) {
                    markup.push(html `<p class="indent">I would prefer to have:</p>`);
                    let preferredList = item.provisions.preferred.map(provision => html `<li><span>${star}</span><p><strong>${provision.name}</strong><br>${provision.description}</p></li>`);
                    markup.push(html `<ul class="preferred">${preferredList}</ul>`);
                }
                if (markup.length == 0) {
                    return '';
                }
                let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                return html `\n                    <details class="provisions">\n                    <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                    e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                } }} />${item.title}</summary>\n                    <div class="panel">\n                        ${markup}\n                    </div>\n                </details>\n                `;
            });
            let hasProvisions = provisionsLoop ? provisionsLoop.filter((item) => item != '') : [];
            let provisionsPre = '';
            if (hasProvisions.length == 0) {
                if (this.provisions?.length == 0) {
                    provisionsPre = html `<allin-loader loading></allin-loader>`;
                }
                else {
                    provisionsPre = html `<p class="small">${this.member.firstName} ${this.member.lastName} has no access details yet</p>`;
                }
            }
            else {
                provisionsPre = html `<div class="collapsers">\n\t\t\t\t\t<button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all</button>\n\t\t\t\t\t<button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all</button>\n\t\t\t\t</div>`;
            }
            main = html `\n                <div class="bg">\n                    <dl class="details grid">\n                        ${details}\n                    </dl>\n                    <h2>Access details</h2>\n                    ${provisionsPre}\n                    ${provisionsLoop}  \n                </div>\n            `;
        }
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-organisation-event-form-edit-${this.name}`, { eventId: this.event });
    }
    async _fetchProvisions() {
        let url = `${this.restUrl}?action=get_all_member_provisions&nonce=${this.nonce}`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this.provisions = data.provisions;
            this._loading = false;
            this._setMembershipProvisionsToSessionStorage();
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _getAccessibilityIcons(provisions) {
        let accessibilityIcons = [];
        let provisionMap = [];
        this.provisions?.forEach(prov => {
            provisionMap = [...provisionMap, ...prov.provisions];
        });
        if (provisions && provisions.length) {
            provisions.forEach(prov => {
                let provision = provisionMap.find(p => p.id === prov.standardId);
                if (provision?.filterCategory && !accessibilityIcons.includes(provision?.filterCategory)) {
                    accessibilityIcons.push(provision?.filterCategory);
                }
            });
        }
        accessibilityIcons.sort();
        accessibilityIcons = accessibilityIcons.map(cat => {
            let icon = this.accessibilities?.find(a => a.name === cat);
            if (icon) {
                return html `<li class="icon" title="${icon.label}">\n                    <span class="screen-reader-text">{icon.label} icon</span>\n                    <span aria-hidden="true">\n                        ${unsafeHTML(icon.icon ?? '')}\n                    </span>\n                </li>`;
            }
        });
        accessibilityIcons = accessibilityIcons.filter(icon => icon);
        return accessibilityIcons;
    }
    _handleGoBack(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-event-go-back-${this.name}`, { hide: true });
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    static styles = [
        accessibility,
        grid,
        details,
        css `
        :host{
            width:100%;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
            margin-top:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        h2{
            font-size:1.5rem;
            color:var(--allin-highlight-color,#472961);
        }
        .image-grid{
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            container-type: inline-size;
        }

        .grid--featured{
            flex-basis: 100%;
            background-color: transparent;
            max-height: 450px;
            line-height: 0;
        }
        .grid--image {
            flex-shrink: 1;
            flex-grow: 0;
            flex-basis: 0;
            height: 150px;
        }
        .grid--image:has(:focus){
            outline: 4px solid var(--allin-highlight-color, #472961);       
        }
        .grid--featured img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: top;
            line-height: 0;
        }
        .grid--image img{
            width: auto;
            height: 100%;
            object-fit: cover;
            /* object-position: top; */
            max-width: calc(33cqw - 0.67rem);
        }

        .grid--image.selected{
            outline: 4px solid var(--allin-secondary-color,#FFCE58);
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
        }
        .provisions summary{
            padding:1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .grid--icon {
            grid-template-columns: 1.6rem 1fr;
            gap: 1.5rem;
            margin-bottom: 1rem;
            width: 100%;
        }

        p{
            margin-top:0;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions summary::after {
            right: 1rem;
            top: 1.2rem;
        }

        .instances{
            margin-top:2rem;
        }
        .instance-list{
            list-style:none;
            padding:0;  
            margin:0;
        }
        .instance-list .instance{
            display:grid;
            grid-template-columns:1fr auto;
            gap:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
            padding-bottom:1rem;
        }

        .instance-list .instance ul{
            grid-column:span 2;
        }
        
        .instance-list .instance:last-child{
            border-bottom:none;
        }
        .instance-list .instance .arrow{
            margin-top:1rem;
        }
        .instance-list .provision-list{
            list-style:none;
            display:grid;
            grid-template-columns:1fr 1fr ;
            gap:1rem;
            padding:0;
            margin:0;
        }
        @media (min-width:1000px){
            .instance-list .provision-list{
                grid-template-columns:1fr 1fr 1fr ;
            }
        }
        .instance-list .provision-list li{
            padding:0.5rem;
            border-radius:2px;
            border:1px solid #707070;
        }
        .instance-list .provision-list li h4{
            margin-top:0;
            margin-bottom:0;
            font-size:0.8rem;
        }
        .arrow{
            display:flex;
            align-items:center;
            gap:0.5rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            text-decoration:underline;
            text-decoration-gap:0.2rem;
            span{
                text-decoration:none;
                transition:transform var(--transition) ease;
            }
            &:hover{
                span{
                    transform:translateX(0.3rem);
                }
            }
        }
        @media (prefers-reduced-motion: reduce) {
            .arrow span:hover{
                transform: none;
            }
        }
        .description{
            margin-top:2rem;
            margin-bottom:2rem;
        }
        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            display:block;
            width:100%;
            margin-top:2rem;
            box-sizing: border-box;
            text-align: center;
            &:hover{
                background-color:var(--allin-button-bg-hover-color,#725A88);
            }
        }

        dl{
            row-gap:1rem;
            column-gap:3rem;
            dd{
                font-weight:bold;
                margin:0;
                ul{
                    list-style:none;
                    padding:0;
                    margin:0;
                    li{
                        display:grid;
                        column-gap:1rem;
                        row-gap:0.5rem;
                        align-items:center;
                        
                        margin-bottom:0.5rem;
                        .status{
                            font-size:0.875rem;
                            display:inline-block;
                            background-color:var(--white,#fff);
                            padding:0.2rem 0.4rem;
                            width:fit-content;
                            font-weight:400;
                        }
                    }
                }
            }
        }
        @media screen and (min-width:700px){
            dl{
                grid-template-columns: 1fr 2fr;
                dd{
                    ul{
                        li{
                            grid-template-columns: auto auto;
                        }
                    }
                }
            }
        }
        .indent,ul.required,ul.preferred{
            margin-left:1.5rem;
            padding:0;
        }
        ul.required,ul.preferred{
            list-style:none;
            li{
                display:grid;
                grid-template-columns: 1rem auto;
                gap:1rem;
            }
        }
        `
    ];
}
